import { Paper } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props) => (
	<Paper {...p} {...p.customProps}>
		{p.children}
	</Paper>
))
